import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import '@/App.css';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import Home from '@/pages/Home';
import About from '@/pages/About';
import Foundation from '@/pages/Foundation';
import Services from '@/pages/Services';
import Pricing from '@/pages/Pricing';
import Products from '@/pages/Products';
import YouTuberProgram from '@/pages/YouTuberProgram';
import DigiMitra from '@/pages/DigiMitra';
import Community from '@/pages/Community';
import Support from '@/pages/Support';
import Contact from '@/pages/Contact';
import Admin from '@/pages/Admin';
import AdminLogin from '@/pages/AdminLogin';
import AdminDashboard from '@/pages/AdminDashboard';
import AdminAppointmentSlots from '@/pages/AdminAppointmentSlots';
import AdminBookings from '@/pages/AdminBookings';
import AdminLeads from '@/pages/AdminLeads';
import ContentManagement from '@/pages/ContentManagement';
import CampaignManager from '@/pages/CampaignManager';
import CausesHome from '@/pages/causes/CausesHome';
import CausesLogin from '@/pages/causes/CausesLogin';
import CausesRegister from '@/pages/causes/CausesRegister';
import CreatePetition from '@/pages/causes/CreatePetition';
import CausesDashboard from '@/pages/causes/CausesDashboard';
import TermsOfUse from '@/pages/TermsOfUse';
import PrivacyPolicy from '@/pages/PrivacyPolicy';
import RefundPolicy from '@/pages/RefundPolicy';
import FAQs from '@/pages/FAQs';
import DataDeletionRequest from '@/pages/DataDeletionRequest';
import { Toaster } from '@/components/ui/sonner';
import MetaPixelRouteTracker from '@/components/MetaPixelRouteTracker';

function App() {
  return (
    <HelmetProvider>
      <Router>
        <div className="App">
          <Toaster position="top-center" richColors />
          <MetaPixelRouteTracker />
          <Routes>
            {/* Admin routes without Navbar/Footer */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/admin/content" element={<ContentManagement />} />
            <Route path="/admin/campaigns" element={<CampaignManager />} />
            <Route path="/admin/whatsapp-groups" element={<Admin />} />
            <Route path="/admin/appointments" element={<AdminAppointmentSlots />} />
            <Route path="/admin/bookings" element={<AdminBookings />} />
            <Route path="/admin/leads" element={<AdminLeads />} />
            
            {/* Public routes with Navbar/Footer */}
            <Route path="/*" element={
              <>
                <Navbar />
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/about" element={<About />} />
                  <Route path="/foundation" element={<Foundation />} />
                  <Route path="/Foundation" element={<Foundation />} />
                  <Route path="/services" element={<Services />} />
                  <Route path="/pricing" element={<Pricing />} />
                  <Route path="/products" element={<Products />} />
                  <Route path="/youtuber-program" element={<YouTuberProgram />} />
                  <Route path="/digimitra" element={<DigiMitra />} />
                  <Route path="/community" element={<Community />} />
                  <Route path="/donate" element={<Support />} />
                  <Route path="/contact" element={<Contact />} />
                  <Route path="/causes" element={<CausesHome />} />
                  <Route path="/causes/login" element={<CausesLogin />} />
                  <Route path="/causes/register" element={<CausesRegister />} />
                  <Route path="/causes/start" element={<CreatePetition />} />
                  <Route path="/causes/dashboard" element={<CausesDashboard />} />
                  <Route path="/terms" element={<TermsOfUse />} />
                  <Route path="/privacy" element={<PrivacyPolicy />} />
                  <Route path="/refund" element={<RefundPolicy />} />
                  <Route path="/faqs" element={<FAQs />} />
                  <Route path="/data-deletion" element={<DataDeletionRequest />} />
                </Routes>
                <Footer />
                {/* Floating WhatsApp Button */}
                <a
                  href="https://wa.me/918920455730?text=Hi%20Elderra%2C%20I%20need%20help"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="wa-float"
                  data-testid="whatsapp-float-btn"
                  aria-label="Chat on WhatsApp"
                >
                  <svg viewBox="0 0 24 24" width="28" height="28" fill="white">
                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
                  </svg>
                </a>
              </>
            } />
          </Routes>
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;